export default __webpack_public_path__ + "static/espaco-gourmet-2e85ef44a6913e45886511d79b05ed0c.jpg";